import {
  ActionReducer,
  ActionReducerMap,
  MetaReducer
} from '@ngrx/store';
import * as AppActions from '@store/actions/app.actions';
import * as fromApp from '@store/reducers/app.reducer';
import * as fromEmployee from '@store/reducers/employee.reducer';
import * as fromReservationList from '@store/reducers/reservation-list.reducer';
import * as fromReservation from '@store/reducers/reservation.reducer';
import * as fromTablesPlan from '@store/reducers/tables-plan.reducer';
import { environment } from '../../environments/environment';


export interface State {

  [fromApp.appFeatureKey]: fromApp.State;

  [fromEmployee.employeeFeatureKey]: fromEmployee.State;

  [fromReservationList.reservationListFeatureKey]: fromReservationList.State;

  [fromReservation.reservationFeatureKey]: fromReservation.State;

  [fromTablesPlan.tablesPlanFeatureKey]: fromTablesPlan.State;

}

export const reducers: ActionReducerMap<State> = {

  [fromApp.appFeatureKey]: fromApp.reducer,

  [fromEmployee.employeeFeatureKey]: fromEmployee.reducer,

  [fromReservationList.reservationListFeatureKey]: fromReservationList.reducer,

  [fromReservation.reservationFeatureKey]: fromReservation.reducer,

  [fromTablesPlan.tablesPlanFeatureKey]: fromTablesPlan.reducer,

};

export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {

    if (action.type === AppActions.logout.type) {
      if ((action as any).dontRestState !== true) {
        state = undefined;
      }
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<State>[] = !environment.production ? [clearState] : [clearState];
